import React, { Component, useEffect, useState } from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import { useTranslation } from "react-i18next";
import "../translations/i18n";
import {  useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { transLabel } from '../translations/util';



const CodeTracking = () => {
    const translations = useSelector(state => state.translationReducer);
    const caseRedux = useSelector(state => state.caseReducer);
    const [translation, setTranslation] = useState([]);
    const navigate = useNavigate();
    const [isCopied, setIsCopied] = useState(false);
    let copyText = caseRedux.data.caso.tokenIdentificador;
    const toPage= (page) => {
        navigate(page) 
    }

    useEffect(() => {
        setTranslation(translations.data);
      }, [translations]);



  // This is the function we wrote earlier
  async function copyTextToClipboard(text) {
    if ('clipboard' in navigator) {
      return await navigator.clipboard.writeText(text);
    } else {
      return document.execCommand('copy', true, text);
    }
  }

  // onClick handler function for the copy button
  const handleCopyClick = () => {
    // Asynchronously call copyTextToClipboard
    copyTextToClipboard(copyText)
      .then(() => {
        // If successful, update the isCopied state value
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 1500);
      })
      .catch((err) => {
        console.log(err);
      });
  }

    const { t } = useTranslation();
        return (
            <>
                <Header />
                    <div id="banner-inboard" className="container-fluid">
                        <div className="d-flex align-items-center ps-4">
                                <img className="float-start" src="assets/img/capital-letter-ethics-channel-ayesa.png"/>
                                <h1 className="ps-3 text-white">{transLabel("case.title2")}</h1>
                        </div>          
                    </div>
                    
                    <nav className="ps-3"  aria-label="breadcrumb">
                        <ol className="breadcrumb py-2">
                            <li className="breadcrumb-item"><a href="#" onClick={(e)=>{toPage("/");}}>{transLabel("NewCase.title")}</a></li>
                            <li className="breadcrumb-item active" aria-current="page">{transLabel("CodeTracking.title")}</li>
                        </ol>
                    </nav>


                    <div className="container">
                        <div className="row justify-content-md-center">
                            <div id="intro" className="col-lg-8 align-self-center p-5 mt-5" style={{background: "#FCF5E5"}}>
                                <div className="float-start">
                                    <img src="assets/img/icon-tracking.png" className="me-3"/>
                                </div>
                                <div className="float-start col-sm-10 pt-2">
                                    <h2 style={{fontWeight:"600"}}>{transLabel("CodeTracking.title")}</h2>
                                    <div dangerouslySetInnerHTML={{ __html: transLabel("CodeTracking.title2")}}></div>
                                    <h3 className="p-2 my-4" style={{background:"white", BorderRadius:"8px"}}>{caseRedux.data.caso.tokenIdentificador}</h3>
                                    <button type="button" onClick={handleCopyClick} className="btn btn-primary">{transLabel("CodeTracking.btnCopy")} <span className="ms-3" style={{fontFamily: "Material Icons"}}>content_copy</span></button>
                            
                                </div>
                            </div>
                            <div id="intro" className="col-lg-8 d-flex align-items-center">
                                <div>
                                    <span style={{fontFamily: "Material Icons", color:"#CED4DA", fontSize:"2rem"}} className="float-start px-2">info</span>
                                </div>
                                <div>
                                    <h6 className="pt-2"> El Órgano de Cumplimiento le informará una vez haya realizado un análisis preliminar de la comunicación. <br/>Recibirá un correo con un enlace donde deberá confirmar su identidad. Recuerde la contraseña que ha utilizado para el registro ya que la deberá utilizar para acceder a la información del caso.</h6>
                                </div>
                            </div>
                        </div>
                    </div>       
                <Footer />
            </>
        );
}

export default CodeTracking;